<template>
  <div>
    <div
      v-if="isHomePage === false"
      class="back-button"
    >
      <v-btn
        large
        icon
        @click="goback"
      >
        <v-icon large>keyboard_backspace</v-icon>
      </v-btn>
    </div>
    <v-img
      class="mt-5 text-xs-center"
      :src="myLogo"
      height="65px"
      contain
    ></v-img>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isNavigationFailure } from 'vue-router/src/util/errors'

export default {
  computed: {
    ...mapGetters('config', [
      'theme', 'banner', 'logo', 'logoDark'
    ]),
    myLogo () {
      return this.logoDark ? this.logoDark : window.config.sharedPictures + 'logo.png'
    },
    isHomePage () {
      return (this.$route.name === 'outlets' || this.$route.name === 'welcome' || this.$route.name === 'home' || this.$route.name === 'menu' || this.$route.name === 'register2')
    }
  },
  methods: {
    goback () {
      switch (this.$route.name) {
        case 'password.request':
          this.$router.push({ name: 'login' })
          return
        case 'login':
        case 'register':
        default:
          this.$router.push({ name: 'welcome' }).catch(failure => {
            if (isNavigationFailure(failure)) {
              // show a small notification to the user
            }
          })
          return
      }
    }
  }
}
</script>

<style scoped>
.back-button {
  position: absolute;
  z-index: 200;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue